'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = require('./style');

var getDirectionProp = function getDirectionProp(template) {
  return function (dir) {
    return template(dir);
  };
};
var getWidthProp = getDirectionProp(function (dir) {
  return 'border' + dir + 'Width';
});
var getStyleProp = getDirectionProp(function (dir) {
  return 'border' + dir + 'Style';
});

var getDirections = function getDirections(props) {
  var directions = [];
  if (props.borderTop) directions.push('Top');
  if (props.borderRight) directions.push('Right');
  if (props.borderBottom) directions.push('Bottom');
  if (props.borderLeft) directions.push('Left');
  return directions.length ? directions : null;
};

module.exports = function (props) {
  var directions = getDirections(props);
  var borderWidths = directions ? directions.map(function (dir) {
    return style({
      key: 'borderWidths',
      prop: 'borderWidth',
      cssProperty: getWidthProp(dir),
      numberToPx: true
    })(props);
  }) : [style({
    key: 'borderWidths',
    prop: 'borderWidth',
    numberToPx: true
  })(props)];

  var borderStyles = directions ? directions.map(function (dir) {
    return (0, _defineProperty3.default)({}, getStyleProp(dir), 'solid');
  }) : [{ borderStyle: 'solid' }];

  return props.borderWidth || props.borderWidth === 0 ? _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(borderWidths), (0, _toConsumableArray3.default)(borderStyles))) : null;
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/border-width.js
// module id = 369
// module chunks = 168707334958949